import React from 'react';

import { Label, LabelProps } from '@eika/label';

import {
    CardBlockCode,
    CardControlPanelObject,
    CardLabelInfo,
    CardOrderStatus,
    Kortstatus,
    Market,
    SiteCoreDictionary,
} from './types';

export const replaceXWithBullet = (inputString: string): string => inputString.replace(/x/g, '•');

// -------- DEPRECATED BELOW --------

export const getCardLabels = (
    { status, cardOrderStatus, otherOwnerName, isExpired, market, block }: CardLabelInfo,
    dictionary: SiteCoreDictionary,
    smallSize: boolean,
): LabelProps[] => {
    const isSystemSoftBlocked = () =>
        status === Kortstatus.SYSTEM_SOFTBLOCKED || (block && block.code === CardBlockCode.WARM_CARD);

    const isSoftBlocked = () => status === Kortstatus.SOFTBLOCKED || (block && block.code === CardBlockCode.SOFT_BLOCK);

    const isHardBlocked = () =>
        status === Kortstatus.HARDBLOCKED || (block && !isSystemSoftBlocked() && !isSoftBlocked());

    const hasOrderStatus = status === Kortstatus.ORDERED;
    const cardIsSentToCustomer = cardOrderStatus === CardOrderStatus.SENT_TO_CUSTOMER;

    const idemiaIsProducing =
        cardOrderStatus !== CardOrderStatus.UNKNOWN && cardOrderStatus !== CardOrderStatus.PRODUCED;

    const labels: LabelProps[] = [];

    if (market === Market.BUSINESS) {
        labels.push({
            id: 'card-business-debit-card',
            text: 'Bedriftskort',
            size: smallSize ? 'small' : 'standard',
            type: 'info',
        });
    }

    if (isSoftBlocked()) {
        labels.push({
            id: 'card-block-status',
            text: dictionary.cardLabelSoftBlocked,
            size: smallSize ? 'small' : 'standard',
            type: 'error',
        });
    }

    if (isSystemSoftBlocked()) {
        labels.push({
            id: 'card-block-status',
            text: dictionary.cardLabelSystemSoftBlocked,
            size: smallSize ? 'small' : 'standard',
            type: 'error',
        });
    }

    if (isHardBlocked()) {
        labels.push({
            id: 'card-block-status',
            text: dictionary.cardLabelBlocked,
            size: smallSize ? 'small' : 'standard',
            type: 'error',
        });
    }

    if (hasOrderStatus || (idemiaIsProducing && !cardIsSentToCustomer)) {
        labels.push({
            id: 'card-production-status',
            text: dictionary.cardLabelOrdered,
            size: smallSize ? 'small' : 'standard',
            type: 'info',
        });
    }

    if (isExpired) {
        labels.push({
            id: 'card-is-expired',
            text: dictionary.cardLabelExpired,
            size: smallSize ? 'small' : 'standard',
            type: 'warning',
        });
    }

    if (otherOwnerName) {
        labels.push({
            id: 'card-owner',
            text: `${otherOwnerName} eier kortet`,
            size: smallSize ? 'small' : 'standard',
            type: 'warning',
        });
    }

    return labels;
};

export const getLabelElements = (cardLabelInfo: CardLabelInfo, dictionary: SiteCoreDictionary, smallSize = true) => {
    const labelItems = getCardLabels(cardLabelInfo, dictionary, smallSize);

    return labelItems.map(({ id, text, type, size }) => <Label key={id} text={text} type={type} size={size} />);
};

// -------- CARD FUNCTIONALITY --------

const isBlocked = ({ labelInfo }: CardControlPanelObject) =>
    labelInfo.status === Kortstatus.SOFTBLOCKED ||
    labelInfo.status === Kortstatus.SYSTEM_SOFTBLOCKED ||
    labelInfo.status === Kortstatus.HARDBLOCKED;

const isActive = ({ labelInfo }: CardControlPanelObject) => labelInfo.status === Kortstatus.ACTIVE;

export const digitalCardFunctionAvailable = (card: CardControlPanelObject) =>
    card.isOwnedByUser && !isBlocked(card) && !card.isOrderedToNets;

export const seePinFunctionAvailable = (card: CardControlPanelObject) =>
    card.isOwnedByUser && isActive(card) && !card.isOrderedToNets;
